import { render, staticRenderFns } from "./FooterLanding.vue?vue&type=template&id=33d28529&scoped=true&"
import script from "./FooterLanding.vue?vue&type=script&lang=js&"
export * from "./FooterLanding.vue?vue&type=script&lang=js&"
import style0 from "./FooterLanding.vue?vue&type=style&index=0&id=33d28529&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d28529",
  null
  
)

component.options.__file = "FooterLanding.vue"
export default component.exports